import { ApiRoutes } from "../../../../../constants/api";
import { BaseAPI, RequestMethod } from "../../../base";
import { CouponValidateRequestBody, CouponValidateResponse } from "./types";

export class CouponValidateAPI extends BaseAPI<
  CouponValidateRequestBody,
  CouponValidateResponse
> {
  protected route = ApiRoutes.coupon.validate;
  protected method = RequestMethod.POST;
}
